import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { OrderItem, PromoCodeUse } from '@queries/generated';

@Component({
  selector: 'vnm-order-receipt-item',
  templateUrl: './order-receipt-item.component.html',
  styleUrls: ['./order-receipt-item.component.scss']
})
export class OrderReceiptItemComponent implements OnInit {
  @ViewChild('orderItemTemplate', { static: true }) orderItemTemplate;

  @Input() orderItem: OrderItem;
  @Input() promoCodeUse: PromoCodeUse;

  constructor(private viewContainerRef: ViewContainerRef) {}

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.orderItemTemplate);
  }

  get isPromoted(): boolean {
    return this.promoCodeUse !== undefined;
  }
}
